
const state = {
  address: '',
  data: {},
  due_date: '',
  id: null,
  instruction_image_file: '',
  instructions: '',
  order_item_id: undefined,
  order_item_task_type_id: undefined,
  provider_employee_id: undefined,
  provider_id: undefined,
  status_id: undefined,
}

export const requiredFields = [
  { key: 'address' },
  { key: 'order_item_task_type_id' },
]

export default state
